/**
 *    Kateogri sayfası JS'leri
 *    Kategoride bulunan görseller mouseover edildiğinde solunda thumbnail galeri görünmesini sağlayan JS'ler
 *    Slider ve menu JS'leri
 */

//Product Carousel Mouseover edildiğinde hover efekti şimdilik kapalı

Vivense.init['category'] = Vivense.init['category'] || [];
Vivense.init['search'] = Vivense.init['search'] || [];
Vivense.init['upholstery-fabric'] = Vivense.init['upholstery-fabric'] || [];

window.viveCategoryPage = window.viveCategoryPage || {};

var categoryListJS = function () {

    var searchBody = $('#search-body');

    var bottomDiv = $("#BottomDiv");

    var products = [];


    window.viveCategoryPage.dataLayerPushedProducts = [];


    var snapbackCache = SnapbackCache({
        bodySelector: $("#product-list-wrapper")
    });

    function isMobile() {

        bottomDiv = $("#BottomDiv");

        return parseInt(bottomDiv.length);
    }

    function getSku(element) {
        return element.data('product-sku');
    }

    function getCategory(element) {
        return element.data('category');
    }

    function getBreadcrumb(element) {
        return element.data('breadcrumb');
    }

    function getPosition(element) {
        return element.data('position');
    }

    function createDataLayerProduct(element) {
        return {
                'name': element.data('product-name'),
                'id': getSku(element),
                'price': element.data('product-price'),
                'brand': 'Vivense',
                'category': getCategory(element),
                'variant': '',
                'list': element.data('list') + ' Listing',
                'position': getPosition(element),
                'dimension11' : element.data('discount-rate').toString(), //Discount rate
                'dimension12': parseInt(element.data('on-showroom')) ? 'Yes' : 'No', //Is there on showroom
                'dimension13':element.data('image-count').toString() // Number of pictures
             }
    }

    function onImageAppear(element) {

        function pushProduct() {

            products.push(createDataLayerProduct(element));
        }

        function datalayerPush() {
            if(products.length > 0) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'Category': 'Enhanced Ecommerce',
                    'Action': 'Product',
                    'Label': 'Impressions',
                    'Value': 0,
                    'noninteraction': true,
                    'ecommerce': {
                        'currencyCode': 'TRY',
                        'impressions': products
                    },
                    'event': 'eeEvent'
                });
            }
        }

        if (window.viveCategoryPage.dataLayerPushedProducts.indexOf(element.data('product-sku')) === -1) {

            window.viveCategoryPage.dataLayerPushedProducts.push(element.data('product-sku'));
            pushProduct();

            if(($( window ).width() > 1079 && products.length === 4) ||
                $( window ).width() <= 1079 && products.length === 2){
                datalayerPush();
                products = [];
            }

        }
    }


    function cacheOperations(callBackFunc){
        if (! isMobile()) {
            callBackFunc();
            return;
        }

        try {
            history.replaceState({infiniteScroll: true}, document.title);
            snapbackCache.cachePage(null, callBackFunc);
        } catch (exception) {
            console.log(exception);
            try { snapbackCache.clearAll(); } catch (ignore) { /* ignore exception */ }
            callBackFunc();
        }
    }

    window.viveCategoryPage.lazyLoadImages = function () {
        var lazyImages = $("img.lazy");

        lazyImages.lazyload({
            effect: "fadeIn",
            threshold: 200,
            placeholder: "/images/img/placeholders/categories_product_no_image_2.jpg"
        });
    };

    window.viveCategoryPage.initFiltersToggle = function () {

        var filterTitleList = $(".filters_title_list");

        filterTitleList.children("li").on("click", function () {

            var thisItem = $(this);
            var thisIndex = $(this).index();
            var filtersInnerWrapper = $(".filters_inner_wrapper");
            var filtersInnerList = $(".filters_inner_list");

            if (filtersInnerWrapper.is(':visible')) {

                if (thisItem.hasClass("open_filter")) {

                    thisItem.removeClass("open_filter");
                    filtersInnerWrapper.slideUp()


                } else {

                    filtersInnerList.removeClass("active_filter")
                    filtersInnerList.eq(thisIndex).addClass("active_filter")

                    filterTitleList.children("li").removeClass("open_filter");
                    thisItem.addClass("open_filter");

                }

            } else {

                filtersInnerList.removeClass("active_filter")
                filtersInnerList.eq(thisIndex).addClass("active_filter")
                thisItem.addClass("open_filter")
                filtersInnerWrapper.slideDown()

            }


        });


    };


    window.viveCategoryPage.initRangeScroll = function () {

        var createRangeScroll = function(divId, step) {
            var sliderMin = $(divId + " #min"),
                sliderMax = $(divId + " #max"),
                mobileSliderMin = $(divId + " #mobile_min"),
                mobileSliderMax = $(divId + ' #mobile_max'),
                hiddenInputMin = $(divId + ' input[class="minvalue"]'),
                hiddenInputMax = $(divId +  ' input[class="maxvalue"]');

            var eventFunc = function (event, ui,minInput,maxInput) {
                if (ui.values[0] !== ui.values[1]) {
                    minInput.val(ui.values[0]);
                    maxInput.val(ui.values[1]);
                    hiddenInputMin.val(ui.values[0]);
                    hiddenInputMax.val(ui.values[1]);
                }
            };

            var slider = $(divId + " #slider-range").slider({
                range: true,
                orientation: "horizontal",
                min: 0,
                max: sliderMax.attr("max"),
                values: [sliderMin.val(), sliderMax.val()],
                step: step,
                slide: function(event,ui){
                    eventFunc(event,ui,sliderMin,sliderMax);
                },
                change: function(event,ui){
                    eventFunc(event,ui,sliderMin,sliderMax);
                }
            });

            $(divId +" #min, "+divId+" #max").on('change', function () {
                if (parseInt(sliderMin.val()) > parseInt(sliderMax.val())) {
                    sliderMax.val( parseInt(sliderMin.val()));
                }
                slider.slider( "option", "values", [ sliderMin.val(), sliderMax.val() ] );

            });

            var mobileSlider = $(divId + " #mobile-slider-range").slider({
                range: true,
                orientation: "horizontal",
                min: 0,
                max: mobileSliderMax.attr("max"),
                values: [mobileSliderMin.val(), mobileSliderMax.val()],
                step: step,

                slide: function (event, ui) {
                    eventFunc(event, ui, mobileSliderMin, mobileSliderMax);
                },

                change: function(event,ui){
                    eventFunc(event,ui,mobileSliderMin,mobileSliderMax);
                }
            });

            $(divId + " #mobile_min, "+ divId +" #mobile_max").on('change', function () {

                if (parseInt(mobileSliderMin.val()) > parseInt(mobileSliderMax.val())) {
                    mobileSliderMax.val(parseInt(mobileSliderMin.val()));
                }

                mobileSlider.slider( "option", "values", [ mobileSliderMin.val(), mobileSliderMax.val() ] );

            });

            $(".measure-range-field, .price-range-field").on('change', function() {
                if($(this).attr('id') == 'min') {
                    $(this).closest('.inputs_wrapper').find('.minvalue').val($(this).val());
                }
                if($(this).attr('id') == 'max') {
                    $(this).closest('.inputs_wrapper').find('.maxvalue').val($(this).val());
                }
            });
        };

        createRangeScroll(".deeprange", 5);
        createRangeScroll(".heightrange", 5);
        createRangeScroll(".pricerange", 100);
        createRangeScroll(".widthrange", 5);
        createRangeScroll(".mobilesliderrange",5);
        createRangeScroll(".mobilepricerange", 100);
        createRangeScroll(".mobiledeeprange", 5);
        createRangeScroll(".mobileheightrange", 5);
        createRangeScroll(".mobilewidthrange", 5);
    };


    window.viveCategoryPage.initOtherColors = function(){


        $(".open_other_product").on("click", function () {
            getOtherProductsPartial($(this).data("product_id"));
            $(".product_other_colours_wrapper").addClass("show_panel");
            $("body").addClass("modal-open");
        });

        function otherProductSlider() {
            $(".other_colours_slider").slick({

                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 1120,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false,
                        }
                    }
                ]
            });
            return false;
        }

        otherProductSlider();

        function calcIconHeight() {

            const cardHeight = $(".product-link .product_images_area a").eq(0).height();
            $(".other_product_opener_mobile").css({top:cardHeight - 22});
            $(".other_size_options_mobile_wrapper").css({top:cardHeight - 22});

        }

        calcIconHeight();

        $(window).resize(function () {
            calcIconHeight()
        });

        function closeModal(){
            $(".close_modal_btn").on("click", function () {
                var productOtherColoursWrapper = $(".product_other_colours_wrapper");
                productOtherColoursWrapper.removeClass("show_panel");
                productOtherColoursWrapper.html("");
                $("body").removeClass("modal-open");
                $('.other_colours_slider').slick('destroy');
            });
        }
        function getOtherProductsPartial(productId){

            $.ajax('/ajax/category/productCustomGroup.php', {
                method: 'post',
                data : 'productId='+productId,
            })
                .done(function (responseData) {

                    $(".product_other_colours_wrapper").html(responseData);
                    otherProductSlider();
                    closeModal();

                })
        }
    };

    window.viveCategoryPage.initBannersSlider = function () {

        var categoryWrapper = $(".category-banner-wrapper__inner");

        categoryWrapper.not(".slick-initialized").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 720,
                    settings: {
                        autoplay: true,
                        arrows:false
                    }
                }
            ]
        });
    };


    window.viveCategoryPage.imageHover = function () {

        $(".hover-product-image").mouseover(function () {

            var thisImg = $(this).data("original");

            var thisIndex = $(this).data("index");

            $(this).closest(".product_img").find(".active-img").attr("src", thisImg);

            var bulletsWrapperLi = $(".bullets_wrapper ul li");
            bulletsWrapperLi.removeClass("active_bullet");

            bulletsWrapperLi.eq(thisIndex).addClass("active_bullet");

            $(this).closest(".hover-element-area").next(".bullets_wrapper").show()

        });

        $(".product_img").mouseout(function () {
            var thisMainImg = $(this).find(".main_image").data("main-img");
            $(this).find(".main_image").attr("src", thisMainImg);
            $(this).find(".bullets_wrapper").hide();
        });
    };

    /* Send custom event to track navigations to PDP from text search. */
    function sendProductClickedFromSearchEvent(element) {
        try {
            var urlSearchParams = new URLSearchParams(window.location.search);
            if (! urlSearchParams.has("q")) {
                return;
            }

            dataLayer.push({
                'event': 'search-to-pdp',
                'category': getCategory(element),
                'breadcrumb': getBreadcrumb(element),
                'sku': getSku(element),
                'position': getPosition(element),
                'query': urlSearchParams.get("q")
            });

        } catch (e) {
            console.log(e);
        }
    }

    function productClickDataLayer(element, isLeftClick) {

        Vivense.cookie.set("lastcategory",element.data('list'),7*24,element.data('url'));
        Vivense.cookie.set("lastbreadcrumb",getBreadcrumb(element),7*24,element.data('url'));

        var navigationDone = false;

        function gotoProductPage() {
            if (navigationDone) return;

            cacheOperations(function () {
                document.location.assign(element.data('url'));
            });

            navigationDone = true;
        }

        if (isLeftClick) {

            if (window['google_tag_manager']) {

                // set a longish timeout so that we will navigate even if the event callback does not fire
                var timeoutId = setTimeout(gotoProductPage, 500);

                sendProductClickedFromSearchEvent(element);

                dataLayer.push({
                    'Category': 'Enhanced Ecommerce',
                    'Action': 'Product',
                    'Label': 'Click',
                    'Value': 0,
                    'noninteraction': false,
                    'ecommerce': {
                        'click': {
                            'actionField': {'list': element.data('list') + ' Listing'},      // Optional list property.
                            'products': [createDataLayerProduct(element)]
                        }
                    },
                    'event': 'eeEvent',
                    'eventCallback': function (containerId) {
                        console.log("datalayer event callback", containerId);
                        if (containerId && !containerId.startsWith("GTM")) {
                            // wait until GTM container runs, there are other Google containers like G-R69E9F0JVM etc.
                            return;
                        }
                        clearTimeout(timeoutId);
                        gotoProductPage();
                    }
                });

            } else {
                // if there's no google tag manager, above event callback won't work, so directly go to the link
                gotoProductPage();
            }
        }
        else {
            dataLayer.push({
                'Category': 'Enhanced Ecommerce',
                'Action': 'Product',
                'Label': 'Click',
                'Value': 0,
                'noninteraction': false,
                'ecommerce': {
                    'click': {
                        'actionField': {'list': element.data('list') + ' Listing'},      // Optional list property.
                        'products': [createDataLayerProduct(element)]
                    }
                },
                'event': 'eeEvent'
            });
        }
    }

    searchBody.on('click', 'a.product-link',
        function (e) {

            if(e.target.className === "favorite-icon"){
                return;
            }
            var element = $(this).parents(".product-content");
            if (!e) e = window.event;
            if (e.ctrlKey || e.metaKey) {

                productClickDataLayer(element, false);
            }
            else if (e.which) {
                if (e.which == 1) {
                    e.preventDefault();
                    productClickDataLayer(element, true);
                }
                else if (e.which == 2) {
                    productClickDataLayer(element, false);
                }
            }

        }
    );

    window.viveCategoryPage.resizeMobileSortingSelect = function () {

        $.fn.resizeSelect = function () {
            return this.each(function () {

                var text = $(this).find("option:selected").text();
                // create tmp element
                var tmp = $("<span>").html(text.trim()).css({
                    "font-size": $(this).css("font-size"), // ensures same size text
                    "visibility": "hidden",
                    "display": "inline-flex"
                });

                // add to body, get width, and get out
                tmp.appendTo($(this).parent());
                var width = tmp.width();
                tmp.remove();

                // set select width
                $(this).width(width);

                scrollUpSticky();

            });
        };

        $("select.mobile-category-sort").resizeSelect();


        $("select.mobile-category-sort").on('change', function() {
            $("html, body").animate({ scrollTop: 0 }, 600);
        });


    };

    window.viveCategoryPage.openMobileFilterMenu = function () {
        $(".mobile-filter-menu-wrapper").addClass("open_menu");
        $("body").addClass("overflow_hidden");
        $(".wrapper-holder").addClass("open-filter-wrapper");
        $(".mobile_layout_wrapper").addClass("open-filter-layout-wrapper");
    };

    window.viveCategoryPage.closeMobileFilterMenu = function () {
        $(".mobile-filter-menu-wrapper").removeClass("open_menu");
        $("body").removeClass("overflow_hidden");
        $(".wrapper-holder").removeClass("open-filter-wrapper");
        $(".mobile_layout_wrapper").removeClass("open-filter-layout-wrapper");
    };

    window.viveCategoryPage.initMobileFilterMenuEvents = function () {

        searchBody.on('click', '.filter-panel-opener', function openFilterMenu() {
            window.viveCategoryPage.openMobileFilterMenu();
        });

        searchBody.on('click', '.mobile-filter-menu-left-side', function closeFilterMenu() {
            window.viveCategoryPage.closeMobileFilterMenu();
        });

        searchBody.on('click', '.mobile-filter-toggle-div', function showFilterOptions() {

            if ($(this).parent('li').hasClass("open-filter-li")) {
                $(this).parent('li').removeClass("open-filter-li");
                $(this).find("i").removeClass("open");
            }
            else {
                $(this).parent('li').addClass("open-filter-li");
                $(this).find("i").addClass("open");
            }

            $(this).parent('li').children(".mobile-filter-option-list").toggle();
        });

        searchBody.on('change', '.mobile-filter-option-list input[type=checkbox]', function () {
            var parentLi = $(this).parents(".mobile-filter");
            var selectedFilters = parentLi.find("input[type=checkbox]:checked");

            var selectedFiltersStr = "";

            var i = 0;
            selectedFilters.each(function () {
                i++;
                selectedFiltersStr += $(this).data("filter-label");
                if (i < selectedFilters.length) {
                    selectedFiltersStr += ", ";
                }
            });

            parentLi.find(".mobile-filter-selected").html(selectedFiltersStr);
        })

    };


    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    window.viveCategoryPage.initInfiniteScroll = function () {

        var looked = false;

        if($(".product-card").last().data("page-id") === undefined)
        {
            return;
        }

        var pageId = parseInt($(".product-card").last().data("page-id"))+1;

        var lastScrollTop = 0;


        $(window).scroll(function () {

            var st = $(this).scrollTop();

            if (st > lastScrollTop) {

                if (isMobile()) {
                    if (isScrolledIntoView(bottomDiv) && !looked) {
                        looked = true;
                        window.viveCategoryPage.loadOtherMobilePages(pageId).then(function (response) {
                            if (response.success) {
                                looked = false;
                                pageId++;
                                bottomDiv.data("page-id", pageId);
                            }
                        })
                    }
                }

                $(".product-card").each(function () {
                    if(isScrolledIntoView($(this))){
                        onImageAppear($(this));
                    }
                })
            }

            lastScrollTop = st;

        });


    };


    window.viveCategoryPage.initCacheEvent = function(){

        var productListWrapper = $("#product-list-wrapper");

        snapbackCache = SnapbackCache({
            bodySelector: productListWrapper
        });

        productListWrapper.on("snapback-cache:loaded", function(e, cachedPage) {
            $("img.lazy.main_image").attr('src',$("img.lazy.main_image").last().data('placeholder'));
            window.viveCategoryPage.initInfiniteScroll();
            window.viveCategoryPage.lazyLoadImages();
        });
    };


    window.viveCategoryPage.initSwiper = function (){

        var swiperOptions = {
            // Default parameters
            slidesPerView: 1,
            spaceBetween: 10,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 4.5,
                    spaceBetween: 10
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 6.5,
                    spaceBetween: 10
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 7.5,
                    spaceBetween: 10
                },
                1120: {
                    slidesPerView: 8.5,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    allowTouchMove: false
                }
            }
        };

        var swiper = new Swiper('.swiper', swiperOptions);

        if($(window).width() < 1024){
            if($('.sub-categories-items__categories .swiper-slide').length < 5) {
                $('.sub-categories-items__categories .swiper-wrapper').addClass('divCenter');
            }
        }else{
            if($('.sub-categories-items__categories .swiper-slide').length < 8) {
                $('.sub-categories-items__categories .swiper-wrapper').addClass('divCenter');
            }
        }
    }

    window.viveCategoryPage.initDynamicElements = function () {
        window.viveCategoryPage.resizeMobileSortingSelect();
        window.viveCategoryPage.lazyLoadImages();
        window.viveCategoryPage.initFiltersToggle();
        window.viveCategoryPage.initBannersSlider();
        window.viveCategoryPage.imageHover();
        window.viveCategoryPage.initRangeScroll();
        window.viveCategoryPage.initInfiniteScroll();
        window.viveCategoryPage.initOtherColors();
        window.viveCategoryPage.initCacheEvent();
        window.viveCategoryPage.initSwiper();
    };

    window.viveCategoryPage.init = function () {
        window.viveCategoryPage.initDynamicElements();
        window.viveCategoryPage.initMobileFilterMenuEvents();

    };

    window.viveCategoryPage.init();

    function scrollUpSticky(){
        var didScroll;
        var lastScrollTop = 0;

        $(window).scroll(function(event){
            didScroll = true;
        });

        setInterval(function(){
            if(didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 200);

        function hasScrolled() {
            var navbarHeight = $('.mobile-filter-header-wrapper').offset().top;
            var st = $(this).scrollTop();

            //eger scroll sticky'den daha yukaridaysa menuyu goster
            if(st < navbarHeight)
            {
                $('.mobile-filter-header-wrapper').removeClass('site-header--fixed_on_mobile').removeClass('site-header--fixed_on_mobile_transition');
                $('.mobile_category_sticky_filter-fixed').removeClass('mobile_category_sticky_filter-fixed-show');
            }

            //eger scroll sticky menu'den daha asagidaysa ve yukari scroll yapilmissa sticky menu'yu fixed yaparak animasyonlu bir sekilde getir
            else if( st > navbarHeight && st < lastScrollTop )
            {
                $('.mobile-filter-header-wrapper')
                    .addClass('site-header--fixed_on_mobile')
                    .removeClass('site-header--fixed_on_mobile_transition');
                $('.mobile_category_sticky_filter-fixed').addClass('mobile_category_sticky_filter-fixed-show');
            }

            //diger tum durumlarda menu'yu gizle gorunuyorsa animasyonu olarak kaybet
            else
            {
                $('.mobile-filter-header-wrapper').removeClass('site-header--fixed_on_mobile');
                $('.mobile_category_sticky_filter-fixed').removeClass('mobile_category_sticky_filter-fixed-show');

                if( st > navbarHeight ) {
                    $('.site-header').addClass('site-header--fixed_on_mobile_transition');
                }
            }

            lastScrollTop = st;
        }
    }

    scrollUpSticky();

    if($('.js-category-banner-close').length > 0) {
        $( ".js-category-banner-close" ).on( "click", function() {
             $(this).parent('.category-banner-wrapper').hide(100);
        });
    }

    $(".category-banner-close").click(function(){
        $("#category_sticky_filter").css({ top: '0' });
    });

    if (!$('.category-banner-wrapper').length) {
        $('.sub-categories-items__title').css('margin-top', '20px');
    }

    function getProductSkuList() {
        var productListElement = $('.product-list');
        var productElements = productListElement.find('.product-card');

        return productElements.map(function () {
            return $(this).data('product-sku');
        }).get();
    }

    if (window.isAdmin) {

        var skuList = getProductSkuList();

        $.ajax('/ajax/category/getAdminInfo.php', {
            method: 'POST',
            data: {
                skuList: skuList,
            }
        })
            .done(function (productList) {
                var products = JSON.parse(productList);

                products.forEach(function (product) {
                    updatePriceTagBySku(product);
                });
            });
    }

    function getBadgeColorBySegment(segment) {
        if (['Luxury', 'Mid'].includes(segment)) {
            return "#1B4D3E"
        } else if (['Midcc', 'Economic'].includes(segment)) {
            return "#0d6491"
        }

        return null;
    }

    function updatePriceTagBySku(product) {
        $('[data-product-sku="' + product.sku + '"]').each(function () {
            var badges = $(this).find('.list-product-cart-badge');

            var color = getBadgeColorBySegment(product.segment);

            if (color) {
                badges.append('<div class="vvns-luna-bedding" style="width: auto;background-color:' + color + ';"><span>Editörün Seçimi</span></div>');
            }
        });
    }


};

Vivense.init['category'].push(categoryListJS);
Vivense.init['search'].push(categoryListJS);
Vivense.init['upholstery-fabric'].push(categoryListJS);
